<template>
    <div>
        <button
            style="background-color: #EFB207;"
            class="px-5 py-2 gap-2 uppercase rounded-md text-black text-opacity-70 text-xs font-medium"
            :class="{'cursor-not-allowed opacity-50': disabled}"
            :disabled="disabled"

            >
            <slot></slot>
        </button>
    </div>
</template>
<script>
export default {
    props: {
        disabled: Boolean,
    }
}
</script>
